import styled, { css } from 'styled-components';
import { lighten, darken } from 'polished';
import { colors } from '../styles/colors';

const Button = styled.button`
  display: block;
  padding: 8px 16px;

  font-family: AzulHelveticaNeue;
  font-size: 20px;
  font-weight: 400;
  line-height: normal;
  height: 56px;
  width: 100%;
  margin-bottom: 16px;

  border: 0 none;
  border-radius: 3px;
  background: transparent;

  cursor: pointer;
  transition: background-color .15s ease, color .15s ease;

  text-align: center;
  &:focus,
  &:active { outline: none; }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  ${props => (props.shadow ? shadowMixin : '')}
  ${props => (props.bold ? boldMixin : '')}

  ${props => (props.lighter ? lighterMixin : '')};
  ${props => (props.primary ? primaryMixin : '')};
  ${props => (props.secondary ? secondaryMixin : '')};
  ${props => (props.gray ? grayMixin : '')};
  ${props => (props.outlineLighter ? outlineLighterMixin : '')};
  ${props => (props.outlinePrimary ? outlinePrimaryMixin : '')};
  ${props => (props.grayText ? grayTextMixin : '')};
  ${props => (props.success ? successMixin: '')};
`;

const shadowMixin = css`
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.25);
`;

const boldMixin = css`
  font-weight: bold;
  padding-top: 12px;
`;

const lighterMixin = css`
  color: white;
  background-color: ${colors.BRAND_LIGHTER};

  &:hover:not(:disabled),
  &:focus:not(:disabled) { background-color: ${darken(0.1, colors.BRAND_LIGHTER)} }
  &:active:not(:disabled) { background-color: ${colors.BRAND_LIGHTER} }
`;

const primaryMixin = css`
  color: white;
  background-color: ${colors.BRAND_PRIMARY};
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.25);

  &:hover:not(:disabled),
  &:focus:not(:disabled) { background-color: ${darken(0.1, colors.BRAND_PRIMARY)} }
  &:active:not(:disabled) { background-color: ${colors.BRAND_PRIMARY} }
`;

const secondaryMixin = css`
  color: white;
  background-color: ${colors.BRAND_SECONDARY};

  &:hover:not(:disabled),
  &:focus:not(:disabled) { background-color: ${lighten(0.1, colors.BRAND_SECONDARY)} }
  &:active:not(:disabled) { background-color: ${lighten(0.2, colors.BRAND_SECONDARY)} }
`;

const successMixin = css`
  color: white;
  background-color: ${colors.SUCCESS};

  &:hover:not(:disabled),
  &:focus:not(:disabled) { background-color: ${darken(0.1, colors.SUCCESS)} }
  &:active:not(:disabled) { background-color: ${colors.SUCCESS} }
`;

const grayMixin = css`
  color: white;
  background-color: ${colors.GRAY_DARKER};

  &:hover:not(:disabled),
  &:focus:not(:disabled) { background-color: ${darken(0.1, '#7F7F7F')} }
  &:active:not(:disabled) { background-color: ${colors.GRAY_DARKER} }
`;

const outlineLighterMixin = css`
  color: ${colors.BRAND_LIGHTER};
  border: 1px ${({ dashed }) => dashed ? 'dashed' : 'solid' } ${colors.BRAND_LIGHTER};

  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    color: white;
    border-color: ${colors.BRAND_LIGHTER};
    background: ${colors.BRAND_LIGHTER};
  }
  &:active:not(:disabled) { background-color: ${darken(0.1, colors.BRAND_LIGHTER)} }
`;

const outlinePrimaryMixin = css`
  color: ${colors.BRAND_PRIMARY};
  border: 1px ${({ dashed }) => dashed ? 'dashed' : 'solid' } ${colors.BRAND_PRIMARY};

  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    color: white;
    border-color: ${colors.BRAND_PRIMARY};
    background: ${colors.BRAND_PRIMARY};
  }
  &:active:not(:disabled) { background-color: ${darken(0.1, colors.BRAND_PRIMARY)} }
`;

const grayTextMixin = css`
  color: ${colors.GRAY_DARKEST};

  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    background: ${colors.GRAY_LIGHT};
  }
  &:active:not(:disabled) { background-color: ${colors.GRAY} }
`;

export default Button;